<template>
  <div class="newhand">
    <!-- 文案 -->
    <div class="newhand-text">
      <div class="newhand-bg"></div>
      <div class="warper clearfix">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <i
              class="iconfont icon-menu-home"
              style="color: var(--theme-color);margin-right:5px"
            ></i>
            <a :href="homeHref" style="color: var(--theme-color)"
              >Help Center</a
            ></a-breadcrumb-item
          >
          <a-breadcrumb-item
            ><span style="color: var(--theme-color)">Release Notes</span></a-breadcrumb-item
          >
        </a-breadcrumb>
        <h1>Release Notes</h1>
        <p>
          Latest update with a detailed explanation of the value of Ruijie Cloud
          <span style="width:2rem"></span> 
        </p>
        <p class="underLine"></p>
      </div>
    </div>
    <div class="warper clearfix">
      <div class="releaseBox">
        <a-row>
          <a-col :span="2"></a-col>
          <a-col :span="18">
            <a-timeline>
              <a-timeline-item
                color="gray"
                v-for="(item, index) in List"
                :key="index"
                position="right"
              >
                <!-- id 为锚点 -->
                <div
                  class="ListBox"
                  id="basic"
                  @click="goUrl(item)"
                  :id="'anchor' + index"
                >
                  <h3 class="ListBoxTitle">{{ item.name | nameFilter }}</h3>
                  <h2>{{ item.name }}</h2>
                  <div>
                    <span v-html="item.detail.replace(/\n/g, '<br/>')"> </span>
                    <span style="color: var(--theme-color); margin-left: 8px">More</span>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-col>
          <a-col :span="4">
            <div class="anchorBox" style="width:100%">
              <p>Update History</p>
              <a-anchor :affix="false" :target-offset="targetOffset" @click="handleAnchor">
                <a-anchor-link
                  v-for="(item, index) in List"
                  :key="'anchorlink' + index"
                  :href="'#anchor' + index"
                  :title="item.name | nameFilter"
                />
              </a-anchor>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import { getIspRelease } from "@/utils/query.js";
export default {
  data() {
    return {
      targetOffset: window.innerHeight / 4,
      List: [],
    };
  },
  filters: {
    nameFilter(value) {
      return value.split(" ")[0];
    },
  },
  mounted() {
    this.getCate();
  },
  computed: {
    isIsp() {
      return sessionStorage.getItem("isIsp") === "true";
    },

    homeHref() {
      const route = this.$router.resolve({ path: this.isIsp ? "/isp" : "/" });
      return route.href;
    },
  },
  methods: {
    async getCate() {
      let res = await getIspRelease();
      if (res.code === 200) {
        let list = res.data.directoryJson.filter((item, index, self) => {
          return item.name == "Release Notes" || item.name == "Coming Soon";
        });

        this.List = list[0].children.reverse();
        //删除末尾多余的回车
        this.List.forEach((item,index)=>{
          let i = item.detail.length -1
          while(item.detail.charAt(i) === '\n') {
            item.detail = item.detail.slice(0,i)
            i--
          }
        })
      }
    },
    goUrl(item) {
      this.$router.push({
        name: "releaseArticle",
        query: { id: item.id },
      });
    },
    handleAnchor(e,link){
      e.preventDefault()
    }
  },
};
</script>
<style scoped>
::v-deep .ant-breadcrumb-separator {
  color: var(--theme-color);
}
/* newhand */
.newhand {
  min-height: 100vh;
  padding-top: 68px;
  position: relative;
}
.newhand-text {
  position: relative;
  padding-top: 2vh;
  padding-bottom: 2rem;
}
.newhand-bg {
  background: url("../../assets/icon/release-bg.png") center no-repeat;
  background-color: var(--bg-page);
  background-size: cover;
  position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
}

.newhand-text h1 {
  margin-top: 1rem;
  text-align: center;
  font-weight: 500;
  font-size: 2rem;
  /* color: var(--text-secondary); */
}
.newhand-text p {
  text-align: center;
  font-size: 14px;
  color: var(--text-secondary);
}

.releaseBox {
  padding-top: 3rem;
}
.ListBox {
  padding-left: 1rem;
  padding-bottom: 2rem;
  cursor: pointer;
  position: relative;
}
.ListBoxTitle {
  position: absolute;
  display: inline-block;
  /* left: 100%; */
  transform: translateX(-160%);
  color: grey;
}
.anchorBox {
  padding-left: 2rem;
  position: fixed;
  height: 50vh;
  overflow-y: scroll;
}
.anchorBox::v-deep .ant-anchor-link-active {
  border-left: 2px solid var(--theme-color);
}
.underLine {
  border-bottom: 3px solid var(--theme-color);
  width: 60px;
  margin: 0 auto;
}
</style>
